<template>
    <page class="page-authorize" title="Authorize">
        <p>
            To execute API calls, you'll need to authorize with the OAuth server. This page lets you specify
            a set of scopes to obtain a token for, then redirects you to the server. This follows the
            authorization code grant.
        </p>
        <span class="authorization-server-url">Authorizing with {{ authorizationServer }}</span>

        <section class="authorize-form">
            <div class="scope-list">
                <checkbox-field v-for="scope in allScopes"
                                v-model="scopes[scope]"
                                @input="toggleScope(scope, $event)"
                                :key="scope"
                                :name="scope"
                                :label="scope"
                                label-visible
                />
            </div>

            <!--<select-field name="scopes" label="Scopes" :options="allScopes" :multiple="true" v-model="scopes"/>
            <text-field name="scopes" label="Scopes" placeholder="Scopes" v-model="scopes"/>-->

            <transition name="fade">
                <div class="authorization-warning" v-show="warning">
                    <span>{{ warning }}</span>
                </div>
            </transition>

            <div class="authorize-form-actions">
                <icon-text-button icon="keyboard_arrow_left" label="Go back" @click="routeBack"
                                  class="back-button"/>
                <icon-text-button icon="checkmark" label="Authorize" @click="authorize" primary
                                  class="authorize-button"/>
            </div>
        </section>
    </page>
</template>

<script>
  import { ROUTE_DOCS } from '../../router';
  import CheckboxField  from '../Forms/CheckboxField';
  import IconTextButton from '../Forms/IconTextButton';
  import SelectField    from '../Forms/SelectField';
  import TextField      from '../Forms/TextField';
  import Page           from '../Layout/Page';

  export default {
    name:       'Authorize',
    components: { CheckboxField, SelectField, TextField, IconTextButton, Page },

    data () {
      return {
        scopes:  [],
        warning: null,
      };
    },

    computed: {
      allScopes () {
        return this.$api.scopes.reduce(( scopes, scope ) => {
          scopes[ scope ] = scope;

          return scopes;
        }, {});
      },

      /**
       * Retrieves the authorization server URL
       *
       * @returns {string}
       */
      authorizationServer () {
        return this.$auth.authorizationUrl;
      },

      /**
       * Retrieves the OAuth client ID
       *
       * @returns {string}
       */
      clientId () {
        return this.$auth.clientId;
      },

      redirectUri () {
        return window.location.origin + '/docs/oauth';
      },

      previousRoute () {
        if ( !this.$route.query.hasOwnProperty('previous') ) {
          return {
            name: ROUTE_DOCS,
          };
        }

        return this.$route.query.previous;
      },
    },

    async mounted () {
      if ( this.$route.query.hasOwnProperty('code') && this.$route.query.code.length > 32 ) {
        const code = this.$route.query.code;

        try {
          await this.$auth.authorize(code, this.redirectUri);

          return this.routeBack();
        } catch ( error ) {
          console.error(error);
          this.warning = error.message;
        }
      }
    },

    methods: {
      routeBack () {
        this.$router.push(this.previousRoute);
      },

      toggleScope ( scope, enabled ) {
        console.log('setting', scope, enabled);

        if ( enabled ) {
          this.scopes.push(scope);
        } else {
          this.scopes.splice(this.scopes.indexOf(scope), 1);
        }
      },

      authorize () {
        const authorizationUrl = new URL(this.authorizationServer);
        authorizationUrl.searchParams.append('response_type', 'code');
        authorizationUrl.searchParams.append('redirect_uri', this.redirectUri);
        authorizationUrl.searchParams.append('client_id', this.clientId);
        authorizationUrl.searchParams.append('scope', this.scopes.join(' '));

        window.location = authorizationUrl;
      },
    },
  };
</script>

<style scoped>
    .page-authorize {
        max-width: 40rem;
        margin:    0 auto;
    }

    .authorize-form {
        margin: 2rem 0;
    }

    .authorize-form-actions {
        display:         flex;
        align-items:     center;
        justify-content: space-between;
        margin-top:      2rem;
    }

    .authorization-warning {
        margin-top:    2rem;
        padding:       1rem;
        border-radius: 3px;
        background:    var(--color-red);
        color:         var(--color-white-bright)
    }

    .scope-list {
        column-count: 2;
        column-rule:  4rem;
    }
</style>
